module.exports = __webpack_public_path__ + "static/media/artist.9d303c41.jpg";